import { createContext } from 'react';

const ShouldGetImagesFromPublicApiContext = createContext(false);

export default ShouldGetImagesFromPublicApiContext;
